export const GET_STATUSES_REQUEST = 'GET_STATUSES_REQUEST';
export const GET_STATUSES_SUCCESS = 'GET_STATUSES_SUCCESS';
export const GET_STATUSES_FAILURE = 'GET_STATUSES_FAILURE';

export const GET_TRANSITIONS_REQUEST = 'GET_TRANSITIONS_REQUEST';
export const GET_TRANSITIONS_SUCCESS = 'GET_TRANSITIONS_SUCCESS';
export const GET_TRANSITIONS_FAILURE = 'GET_TRANSITIONS_FAILURE';

export const SET_STATUSES = "SET_STATUSES";
export const SET_TANSITIONS = "SET_TANSITIONS";

export const getStatusesRequest = (filters = {}, type = "installations") => ({
    type: GET_STATUSES_REQUEST,
    payload: {
        filters,
        type
    }
});

export const getStatusesSuccess = (statuses, type = "installations") => ({
    type: GET_STATUSES_SUCCESS,
    payload: {
        statuses,
        type
    }
});

export const getStatusesFailure = err => ({
    type: GET_STATUSES_FAILURE,
    error: err
});

export const getTransitionsRequest = (status_id, filters = {}, type = "installations") => ({
    type: GET_TRANSITIONS_REQUEST,
    payload: {
        status_id,
        filters,
        type
    }
});

export const getTransitionsSuccess = (transitions, type = "installations") => ({
    type: GET_TRANSITIONS_SUCCESS,
    payload: {
        transitions,
        type
    }
});

export const getTransitionsFailure = err => ({
    type: GET_TRANSITIONS_FAILURE,
    error: err
});

export const setStatuses = (statuses = []) => ({
    type: SET_STATUSES,
    payload: {
        statuses
    }
});

export const setTransitions = (transitions = []) => ({
    type: SET_TANSITIONS,
    payload: {
        transitions
    }
});
